import React from 'react'

const ProfileIcon = ({photo}) => {
  return (
    <div className='border bg-white d-flex justify-content-center align-items-center' style={{ borderRadius: "100%", overflow: "hidden" }}>
        <img className="p-2" width={40} height={40} src={photo} alt={photo} />
    </div>
  )
}

export default ProfileIcon